
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparisons/best-video-review-software",
      function () {
        return require("private-next-pages/comparisons/best-video-review-software.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparisons/best-video-review-software"])
      });
    }
  